import React from "react";
import { useState } from "react";
import styles from "./languageSelector.module.scss";
import i18n, { initialLang } from "../../translations/i18n";
import { ISearchSelectorOptModel } from "../../types/interfaces";
import Selector from "../Selector/Selector";

const languages = [
  { value: "en", text: "English" },
  { value: "es", text: "Español" },
  { value: "eu", text: "Euskara" },
  { value: "gl", text: "Galego" },
  { value: "ca", text: "Català" },
  { value: "de", text: "Deutsch" },
  { value: "fr", text: "Français" },
  { value: "it", text: "Italiano" },
  { value: "pt", text: "Português" },
  { value: "nl", text: "Nederlands" },
];

const defaultLanguageOpt = {
  value: "en",
  text: "English",
};

const LanguageSelector = () => {
  const initialOpt =
    languages?.find((lang) => lang?.value === initialLang) ||
    defaultLanguageOpt;

  // States
  const [language, setLanguage] = useState(initialOpt);

  // Functions
  const changeLanguageHandler = (newLang: ISearchSelectorOptModel) => {
    setLanguage(newLang);
    sessionStorage.setItem("i18nextLng", newLang?.value);
    i18n?.changeLanguage(newLang?.value);
  };

  return (
    <Selector
      className={styles.languageSelector}
      options={languages}
      selectedOption={language}
      setSelectedOption={changeLanguageHandler}
    />
  );
};

export default LanguageSelector;
